import { withTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import ContentWrapper from '@components/ContentWrapper';
import SelectEventContent from '@core/event/components/SelectEventContent';

import { ISelectEventPageViewProps } from './interfaces';
import { useStyles } from './styles';

const SelectEventPageView = ({
  events,
  t: translate,
  selectedEvent,
  setSelectedEvent,
}: ISelectEventPageViewProps) => {
  const classes = useStyles();
  return (
    <ContentWrapper>
      {events.length ? (
        <SelectEventContent
          events={events}
          setSelectedEvent={setSelectedEvent}
          selectedEvent={selectedEvent}
        />
      ) : (
        <>
          <Typography sx={classes.emptyPlaceholderTitle}>
            {translate('eventPage.noEventsTitle')}
          </Typography>
          <Typography sx={classes.emptyPlaceholderBody}>
            {translate('eventPage.noEventsBody')}
          </Typography>
        </>
      )}
    </ContentWrapper>
  );
};

export default withTranslation()(SelectEventPageView);
